/**
 * Wrapper for session storage
 */
class StorageHandler {
    constructor() {
        this.hasStorage = sessionStorage ? true : false;
    }

    /**
     * @param {String} key
     * @param {*} value
     * @returns StorageHandler}
     */
    sessionStore(key, value) {
        if (!this.hasStorage) {
            return;
        }

        try { //Needed for private browsing in Safari
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (ex) {

        }


        return this;
    }

    /**
     * @param string key
     * @returns {boolean | *}
     */
    sessionRetrieve(key) {
        var item;

        if (!this.hasStorage) {
            return false;
        }

        try { //Needed for private browsing in Safari
            item = sessionStorage.getItem(key);
        }
        catch (ex) {
            return false;
        }

        if (item === null) {
            return false;
        }

        return JSON.parse(item);
    }
}

export default StorageHandler;